import React from "react";
import { Text, View } from "@react-pdf/renderer";
import CheckboxGroup from "../../../exportacion_react_pdf/CheckboxGroup";
import TextAreaLabel from "../../../exportacion_react_pdf/TextAreaLabel";
import QuestionResponse from "../../../exportacion_react_pdf/QuestionResponse";

// Define el documento
const ExportPaso5 = ({ formData = {}, styles = {} }) => {
  let totalSumPeriodicidad_ventas = 0;
  let totalSumCosto_ventas = 0;

  const formatNumber = (number) => {
    const roundedNum = Math.round(number).toString();
    if (roundedNum.length <= 3) return roundedNum;

    const lastThree = roundedNum.slice(-3);
    const otherNumbers = roundedNum.slice(0, -3);
    return otherNumbers.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "," + lastThree;
  };

  return (
    <>
      {/* Producto Representativo */}
      <View style={styles.section}>
        <Text style={styles.title_1}>V. Gestión Financiera</Text>

        <CheckboxGroup
          label="¿El proyecto tiene acceso a productos del sector financiero?"
          selectedValue={formData?.acceso_productos_sector_financiero || ""}
        ></CheckboxGroup>
        {formData?.acceso_productos_sector_financiero === "Sí" && (
          <>
            <CheckboxGroup
              label="¿Cuáles productos del sector financiero tiene el proyecto productivo?"
              selectedValue={
                formData?.productos_sector_financiero_proyecto || []
              }
              options={[
                "Cuenta corriente",
                "Cuenta de ahorros",
                "Tarjeta de crédito",
                "Créditos (prestamos bancarios)",
                "Créditos (prestamos no bancarios)",
                "Otros",
              ]}
            />

            {formData?.productos_sector_financiero_proyecto?.includes(
              "Otros"
            ) && (
              <TextAreaLabel
                label={"Indique cuáles"}
                value={
                  formData?.otros_productos_sector_financiero_proyecto ?? ""
                }
              />
            )}
          </>
        )}

        <QuestionResponse
          label={
            "Indique el valor de los activos fijos del proyecto al último mes en (maquinaria, bienes inmuebles y/o semovientes)"
          }
          value={formData?.valor_activos_fijos_mes || ""}
        ></QuestionResponse>

        <QuestionResponse
          label={
            "Indique el valor de las deudas (pasivo) de su proyecto con corte al último mes"
          }
          value={formData?.valor_deudas_pasivo_fijos_mes || ""}
        ></QuestionResponse>

        <CheckboxGroup
          label="Para calcular indicadores es necesario definir la periodicidad de las ventas del proyecto (Mensual, Trimestral, Semestral, Anual)"
          selectedValue={formData?.periodicidad_ventas || ""}
          options={["Mensual", "Trimestral", "Semestral", "Anual"]}
        ></CheckboxGroup>

        <QuestionResponse
          label={
            "Identifique cuál es el valor de los inventarios a precio de costo (activos productivos e insumos) a corte del último periodo"
          }
          value={formData?.valor_inventario_perico_costo || ""}
        ></QuestionResponse>

        <QuestionResponse
          label={
            "Indique cuáles son los ingresos del proyecto en el último periodo"
          }
          value={formData?.ingresos_proyecto_ultimo_periodo || ""}
        ></QuestionResponse>

        <QuestionResponse
          label={"Indique cuáles son los gastos del proyecto mensualmente"}
          value={formData?.gastos_proyecto_mensualmente || ""}
        ></QuestionResponse>

        <Text style={styles.textareaLabel}>
          Teniendo en cuenta la periodicidad de las ventas diligencie el
          siguiente cuadro:
        </Text>
        <View style={styles.table}>
          {/* Encabezados de la tabla */}
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Artículo/ referencia</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Periodicidad</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Precio venta</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Medida</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Cantidad</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Total</Text>
            </View>
          </View>

          {/* Filas de datos */}
          {formData?.lista_periodicidad_ventas &&
          formData?.lista_periodicidad_ventas.length > 0 ? (
            <>
              {formData?.lista_periodicidad_ventas.map((row, index) => {
                totalSumPeriodicidad_ventas += parseFloat(row.total || 0);
                return (
                  <View style={styles.tableRow} key={index}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {row.articulo_referencia || ""}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {row.periodicidad || ""}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {row.precio_venta || ""}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{row.medida || ""}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{row.cantidad || ""}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{row.total || ""}</Text>
                    </View>
                  </View>
                );
              })}
              {/* Fila de suma total */}
              <View style={[styles.tableRow, styles.tableHeader]}>
                <View style={[styles.tableCol_total]}>
                  <Text style={styles.tableCell}>Total de ventas</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    {formatNumber(totalSumPeriodicidad_ventas)}
                  </Text>
                </View>
              </View>
            </>
          ) : (
            <View style={styles.tableRow}>
              <Text style={styles.tableCell}>No hay datos</Text>
            </View>
          )}
        </View>

        <Text style={styles.textareaLabel}>
          Costo de ventas (diligencie el siguiente cuadro, teniendo en cuenta la
          periodicidad de las ventas)
        </Text>
        <View style={styles.table}>
          {/* Encabezados de la tabla */}
          <View style={styles.tableRow}>
            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Artículo/ referencia</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Periodicidad</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Precio venta</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Medida</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Cantidad</Text>
            </View>

            <View style={styles.tableColHeader}>
              <Text style={styles.tableCell}>Total</Text>
            </View>
          </View>

          {/* Filas de datos */}
          {formData?.lista_costo_ventas &&
          formData?.lista_costo_ventas.length > 0 ? (
            <>
              {formData?.lista_costo_ventas.map((row, index) => {
                totalSumPeriodicidad_ventas += parseFloat(row.total || 0);
                return (
                  <View style={styles.tableRow} key={index}>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {row.articulo_referencia || ""}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {row.periodicidad || ""}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>
                        {row.precio_venta || ""}
                      </Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{row.medida || ""}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{row.cantidad || ""}</Text>
                    </View>
                    <View style={styles.tableCol}>
                      <Text style={styles.tableCell}>{row.total || ""}</Text>
                    </View>
                  </View>
                );
              })}
              {/* Fila de suma total */}
              <View style={[styles.tableRow, styles.tableHeader]}>
                <View style={[styles.tableCol_total]}>
                  <Text style={styles.tableCell}>Total de ventas</Text>
                </View>
                <View style={styles.tableCol}>
                  <Text style={styles.tableCell}>
                    {formatNumber(totalSumPeriodicidad_ventas)}
                  </Text>
                </View>
              </View>
            </>
          ) : (
            <View style={styles.tableRow}>
              <Text style={styles.tableCell}>No hay datos</Text>
            </View>
          )}
        </View>

        <CheckboxGroup
          label="¿Los gastos del proyecto se mantienen separados de los gastos personales?"
          selectedValue={formData?.gastos_proyecto_separados_personales || ""}
        ></CheckboxGroup>

        <TextAreaLabel
          label={
            "¿Conjuntamente entre la persona en reincorporación y el asesor identifiquen una fortaleza representativa del proyecto productivo en temas financieros?"
          }
          value={formData?.fortaleza_representativa_temas_financieros || ""}
        ></TextAreaLabel>

        <TextAreaLabel
          label={
            "¿Conjuntamente entre la persona en reincorporación y el asesor identifica una debilidad representativa del proyecto productivo en temas financieros?"
          }
          value={formData?.debilidad_representativa_temas_financieros || ""}
        ></TextAreaLabel>
      </View>
    </>
  );
};

export default ExportPaso5;
